import date from '../../../utils/date.js'

export const presetRanges = [
  {
    label: 'Today',
    start: date().utc(),
    end: date().utc(),
  },
  {
    label: 'Yesterday',
    start: date().utc().subtract(1, 'days'),
    end: date().utc().subtract(1, 'days'),
  },
  {
    label: 'Last 7 Days',
    start: date().utc().subtract(6, 'days'),
    end: date().utc(),
  },
  {
    label: 'Last 30 Days',
    start: date().utc().subtract(29, 'days'),
    end: date().utc(),
  },
  {
    label: 'This Month',
    start: date().utc().startOf('month'),
    end: date().endOf('month').utc(),
  },
  {
    label: 'Last Month',
    start: date().utc().subtract(1, 'month').startOf('month'),
    end: date().utc().subtract(1, 'month').endOf('month'),
  },
  {
    label: 'This Year',
    start: date().utc().startOf('year'),
    end: date().utc(),
  },
  {
    label: 'Last Year',
    start: date().utc().subtract(1, 'year').startOf('year'),
    end: date().utc().subtract(1, 'year').endOf('year'),
  },
  {
    label: 'Lifetime',
    start: date('2011-01-01T00:00:00').utc(),
    end: date().utc(),
  },
]
